import { render, staticRenderFns } from "./DocumentsTableSharing.vue?vue&type=template&id=9e49c8b0"
import script from "./DocumentsTableSharing.vue?vue&type=script&lang=js"
export * from "./DocumentsTableSharing.vue?vue&type=script&lang=js"
import style0 from "./DocumentsTableSharing.vue?vue&type=style&index=0&id=9e49c8b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports